import { useEffect } from 'react'
import { useWorkspace } from './useWorkspace'
import { useClientPreferences } from './useClientPreferences'
import { switchedOffModulesFor } from '../utils/workspaceModules'

export const FunPackThemeBridge = () => {
  const { workspaces = [], activeWorkspaceId } = useWorkspace()
  const effectiveWorkspace = workspaces.find((w) => w.id === activeWorkspaceId) ?? null
  const { setFunPackThemeFallback } = useClientPreferences()

  const funPackOff = effectiveWorkspace ? switchedOffModulesFor(effectiveWorkspace).has('funPack') : false

  useEffect(() => {
    setFunPackThemeFallback(funPackOff)
  }, [funPackOff, setFunPackThemeFallback])

  useEffect(() => {
    return () => {
      setFunPackThemeFallback(false)
    }
  }, [setFunPackThemeFallback])

  return null
}
